import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-aqi-status-bar',
  template: `
           <div class="aqi-container">
            <div class="aqi-labels">
                <ng-container *ngFor="let range of aqiRanges">
                    <div class="label" [style.flex]="range.max - range.min">{{ range.label }}</div>
                </ng-container>
            </div>
            <div class="aqi-bar">
                <ng-container *ngFor="let range of aqiRanges">
                    <div class="aqi-segment" [style.backgroundColor]="range.color" [style.flex]="range.max - range.min">
                    </div>
                </ng-container>

                <ng-container *ngIf="currentAqi">
                    <div class="aqi-pointer animate-pulse" [style.left]="getPointerPosition()">
                        <div class="circle" [style.borderColor]="getPointerColor()"></div>
                    </div>
                </ng-container>
            </div>
            <div class="aqi-values">
                <div *ngFor="let range of aqiRanges" class="value" [style.flex]="range.max - range.min">
                    {{ range.min }}
                </div>
                <div class="value">301+</div>
            </div>
        </div>
  `,
  styles: `
    .aqi-container {
      font-family: sans-serif;
      width: 100%;
      max-width: 800px;
      margin: auto;
    }
    .aqi-bar {
      display: flex;
      height: 10px;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
    }
    .aqi-segment {
      height: 100%;
    }
    .aqi-pointer {
      position: absolute;
      top: -6px;
      transform: translateX(-50%);
    }
    .circle {
      margin-top: 4px;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background-color: white;
      border: 3px solid #f1c40f;
    }
    .aqi-labels,
    .aqi-values {
      display: flex;
      justify-content: space-between;
      margin-top: 8px;
    }
    .label,.value {
      text-align: start;
      font-size: 0.6rem;
    }
    `
})
export class AqiStatusBarComponent {
  @Input({required: true, alias: 'currentAqi'}) currentAqi!: number;
  aqiRanges = [
    { label: 'Good', min: 0, max: 50, color: '#2ecc71' },
    { label: 'Moderate', min: 51, max: 100, color: '#f1c40f' },
    { label: 'Poor', min: 101, max: 150, color: '#e67e22' },
    { label: 'Unhealthy', min: 151, max: 200, color: '#e74c3c' },
    { label: 'Severe', min: 201, max: 300, color: '#9b59b6' },
    { label: 'Hazardous', min: 301, max: 500, color: '#c0392b' },
  ];

  getPointerPosition(): string {
    const max = 500;
    const clampedAqi = Math.min(this.currentAqi, max);
    return `${(clampedAqi / max) * 100}%`;
  }
  getPointerColor(): string {
    const range = this.aqiRanges.find(r => 
      this.currentAqi >= r.min && this.currentAqi <= r.max
    );
    return range?.color || '#f1c40f';
  }
}
